import { Box, Chip, Stack, Typography } from '@mui/material';
import React from 'react';
import { useAgendamentoStore } from '../../store/useAgendamentoStore';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import ContentCutIcon from '@mui/icons-material/ContentCut';

export const InfoAgendamento: React.FC = () => {
  const { servico, data, horario, profissional } = useAgendamentoStore();

  if (!servico) return null;

  return (
    <Box sx={{ mb: 3, p: 2, bgcolor: 'rgba(0,0,0,0.02)', borderRadius: 4, border: '1px dashed rgba(0,0,0,0.1)' }}>
      <Typography variant="caption" fontWeight={800} color="text.secondary" sx={{ display: 'block', mb: 1, textTransform: 'uppercase' }}>
        Sua seleção atual:
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {servico && (
          <Chip 
            icon={<ContentCutIcon sx={{ fontSize: '1rem !important' }} />} 
            label={servico.descricao} 
            size="small" 
            variant="outlined" 
          />
        )}
        {data && horario && (
          <Chip 
            icon={<CalendarTodayIcon sx={{ fontSize: '1rem !important' }} />} 
            label={`${new Date(data + 'T00:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })} às ${horario}`} 
            size="small" 
            variant="outlined" 
          />
        )}
        {profissional && (
          <Chip 
            icon={<PersonIcon sx={{ fontSize: '1rem !important' }} />} 
            label={profissional.nome} 
            size="small" 
            variant="outlined" 
          />
        )}
      </Stack>
    </Box>
  );
};